
// declare namespace JSX {
//   interface IntrinsicElements {
//     'whereby-embed': React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement> & {
//       room?: string;
//     };
//   }
// }

// import '@whereby.com/browser-sdk/embed';


const WherebyRoom = ({ roomUrl }: { roomUrl: string }) => {
  return <div />
  // const EmbedTag = 'whereby-embed' as  any

  // return (
  //   <EmbedTag
  //     room={roomUrl}
  //     style={{ width: '100%', height: '600px', border: '0' }}
  //   />
  // );

};

export default WherebyRoom;